<template>
	<div class="block">
		<slot />
	</div>
</template>

<style>
.block {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 12px 14px;
	gap: 10px;

	background: rgb(52, 36, 19);
	border-radius: 16px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 120%;

	color: #f68700;
}
</style>
